import { TextFieldComponent } from '@anecdotes/design-system/form-controls';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
  ViewChild,
  inject,
  DestroyRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { fromEvent, Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DataFilterManagerService } from '../../services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SearchInputComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  @ViewChild('input')
  private input: TextFieldComponent;

  private changedText$ = new Subject<string>();

  @HostBinding('class')
  private readonly classes = 'inline-block';

  text$: Observable<string>;

  @Input()
  filterInstanceId: string;

  @Input()
  placeholderTranslationKey: string;

  @Input()
  skipFocusing: boolean;

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  search = new EventEmitter<string>();

  constructor(private dataFilterManager: DataFilterManagerService) {}

  ngOnInit(): void {
    this.text$ = this.dataFilterManager.getSearchText(this.filterInstanceId);
    this.changedText$.pipe(debounceTime(500), takeUntilDestroyed(this.destroyRef)).subscribe((searchValue) => {
      this.dataFilterManager.setSearchText(this.filterInstanceId, searchValue);
      this.search.emit(searchValue);
    });

    if (!this.skipFocusing) {
      fromEvent(document, 'keydown')
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(this.handleSearchKeysCombination.bind(this));
    }
  }

  handleChangedText(text: string): void {
    this.changedText$.next(text);
  }

  private handleSearchKeysCombination(event: KeyboardEvent): void {
    // Handles CTRL+F
    if (event.key === 'f' && (event.ctrlKey || event.metaKey)) {
      this.input.focus();

      event.preventDefault();
      event.stopPropagation();
    }
  }
}
